import { useEffect, useRef, useState } from 'react';
import { detectDesktopPlatform } from '@/utils/deviceDetect';
import { PC_DOWNLOADS, type PcDownloadOption } from '../../config';
import styles from './index.module.scss';

export default function PcDownloadButton() {
  const [open, setOpen] = useState(false);
  const [platform] = useState(() => detectDesktopPlatform());
  const rootRef = useRef<HTMLDivElement>(null);

  const primary = PC_DOWNLOADS.find((item) => item.id === platform) ?? PC_DOWNLOADS[0];
  const others = PC_DOWNLOADS.filter((item) => item.id !== primary.id);

  useEffect(() => {
    if (!open) {
      return;
    }

    const onPointerDown = (event: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const renderRow = (item: PcDownloadOption, className: string) => (
    <a key={item.id} className={className} href={item.url} onClick={() => setOpen(false)}>
      <span className={styles.icon}>
        <img src={item.icon} alt="" loading="lazy" />
      </span>
      <span className={styles.copy}>
        <span className={styles.label}>{item.label}</span>
        <span className={styles.hint}>{item.hint}</span>
      </span>
    </a>
  );

  return (
    <div className={styles.root} ref={rootRef}>
      <div className={styles.btn}>
        {renderRow(primary, styles.main)}
        <button
          className={`${styles.expand}${open ? ` ${styles.expandOpen}` : ''}`}
          type="button"
          aria-label="其他版本"
          aria-expanded={open}
          aria-haspopup="true"
          onClick={() => setOpen((prev) => !prev)}
        >
          <span className={styles.caret} aria-hidden />
        </button>
      </div>
      {open ? <div className={styles.menu}>{others.map((item) => renderRow(item, styles.item))}</div> : null}
    </div>
  );
}
